<div class="profile-info-container">
    <div class="info-content">
        <label>Recommended Profile</label>
        <span>{{profileInfo.recommendedProfile}}</span>
    </div>
    <div class="info-content">
        <label>Current Profile</label>
        <span>{{profileInfo.currentProfile}}</span>
    </div>
</div>